import { ReactComponent as More } from "@svgr/webpack?-svgo,+titleProp,+ref!./More.svg";
import { ReactComponent as MenuNotification } from "@svgr/webpack?-svgo,+titleProp,+ref!./MenuNotification.svg";
import { ReactComponent as MenuExpanded } from "@svgr/webpack?-svgo,+titleProp,+ref!./MenuExpanded.svg";
import { ReactComponent as Launcher } from "@svgr/webpack?-svgo,+titleProp,+ref!./LauncherDefault.svg";
import { ReactComponent as Menu } from "@svgr/webpack?-svgo,+titleProp,+ref!./MenuDefault.svg";
import { ReactComponent as LauncherAlert } from "@svgr/webpack?-svgo,+titleProp,+ref!./LauncherAlert.svg";
import { ReactComponent as Close } from "@svgr/webpack?-svgo,+titleProp,+ref!./Close.svg";
import { ReactComponent as Bell } from "@svgr/webpack?-svgo,+titleProp,+ref!./BellDefault.svg";
import { ReactComponent as BellAlert } from "@svgr/webpack?-svgo,+titleProp,+ref!./BellAlert.svg";
export const PlatformIcons = {
  More,
  MenuNotification,
  MenuExpanded,
  Launcher,
  Menu,
  LauncherAlert,
  Close,
  Bell,
  BellAlert
};
export const PlatformIconNames = ["More", "MenuNotification", "MenuExpanded", "Launcher", "Menu", "LauncherAlert", "Close", "Bell", "BellAlert"];